export default __webpack_public_path__ + "static/media/hand-car.9bdd0648.svg";